import log from 'loglevel';

log.setDefaultLevel(process.env.NODE_ENV === 'production' ? 'warn' : 'debug');

export default log;
